<template>
  <div>
    <div class="nav-vertical">
      <ul class="nav nav-tabs nav-left" role="tablist">
        <li class="nav-item">
          <a
            class="nav-link active"
            v-bind:href="'#t1' + rowData.doc_id + ''"
            role="tab"
            data-toggle="tab"
          >
            <span class="nav-link-in">
              Partes envolvidas
              <i class="fa fa-plus"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            v-bind:href="'#t2' + rowData.doc_id + ''"
            role="tab"
            data-toggle="tab"
          >
            <span class="nav-link-in">
              Informações adicionais
              <i class="fa fa-plus"></i>
            </span>
          </a>
        </li>
      </ul>

      <div class="tab-content">
        <div
          role="tabpanel"
          class="tab-pane fade in active show pt-1 border-color-detalhes-grey"
          v-bind:id="'t1' + rowData.doc_id + ''"
        >
          <table class="table-striped" id="mais">
            <thead>
              <tr>
                <th data-toggle="true" style="width: 10%"></th>
                <th data-toggle="true" style="width: 10%">CNPJ</th>
                <th data-toggle="true" style="width: 10%">IE</th>
                <th data-toggle="true" style="width: 10%">Nome</th>
                <th data-toggle="true" style="width: 10%">Município</th>
                <th data-toggle="true" style="width: 3%">Estado</th>
                <th data-toggle="true" style="width: 15%">Endereço</th>
                <th data-toggle="true" style="width: 12%">Bairro</th>
                <th data-toggle="true" style="width: 10%">CEP</th>
                <th data-toggle="true" style="width: 10%">Email</th>
                <th data-toggle="true" style="width: 5%">Telefone</th>
                <th data-toggle="true" style="width: 5%">Ações</th>
              </tr>
            </thead>

            <tbody>
              <tr
                class="bg-gray-light"
                style="display: table-row"
                v-if="rowData.doc_cte_partes_env.emi_endereco"
              >
                <td>
                  <span class="badge badge-secondary">Emitente</span>
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.emi_cnpj }}
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.emi_ie }}
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.emi_nome }}
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.emi_nome_municipio }}
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.emi_uf }}
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.emi_endereco }} -
                  {{ rowData.doc_cte_partes_env.emi_complemento }} -
                  {{ rowData.doc_cte_partes_env.emi_numero }}
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.emi_bairro }}
                </td>
                <td>
                  <span v-if="rowData.doc_cte_partes_env.emi_cep">{{
                    rowData.doc_cte_partes_env.emi_cep.toString().padStart(8, "0")
                  }}</span>
                </td>
                <td>
                  <span v-if="rowData.doc_cte_partes_env.emi_email">{{
                    rowData.doc_cte_partes_env.emi_email
                  }}</span>
                </td>
                <td>
                  <span v-if="rowData.doc_cte_partes_env.emi_telefone">{{
                    rowData.doc_cte_partes_env.emi_telefone
                  }}</span>
                </td>
                <td></td>
              </tr>
            </tbody>

            <tbody>
              <tr
                class="bg-gray-light"
                style="display: table-row"
                v-if="rowData.doc_cte_partes_env.rem_endereco"
              >
                <td>
                  <span class="badge badge-warning">Remetente</span>
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.rem_cnpj }}
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.rem_ie }}
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.rem_nome }}
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.rem_nome_municipio }}
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.rem_uf }}
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.rem_endereco }} -
                  {{ rowData.doc_cte_partes_env.rem_complemento }} -
                  {{ rowData.doc_cte_partes_env.rem_numero }}
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.rem_bairro }}
                </td>
                <td>
                  <span v-if="rowData.doc_cte_partes_env.rem_cep">{{
                    rowData.doc_cte_partes_env.rem_cep.toString().padStart(8, "0")
                  }}</span>
                </td>
                <td>
                  <span v-if="rowData.doc_cte_partes_env.rem_email">{{
                    rowData.doc_cte_partes_env.rem_email
                  }}</span>
                </td>
                <td>
                  <span v-if="rowData.doc_cte_partes_env.rem_telefone">{{
                    rowData.doc_cte_partes_env.rem_telefone
                  }}</span>
                </td>
                <td>
                  <span v-if="getPermission('cte.cderp')"
                    ><a
                      @click="
                        onAlterarCdErp(
                          rowData.doc_cte_partes_env.doctpaen_id,
                          1
                        )
                      "
                      v-b-tooltip
                      title="Alterar CD ERP"
                      ><i class="fa fa-plus"></i></a
                  ></span>
                </td>
              </tr>
            </tbody>

            <tbody>
              <tr
                class="bg-gray-light"
                style="display: table-row"
                v-if="rowData.doc_cte_partes_env.exp_endereco"
              >
                <td>
                  <span class="badge badge-info">Expedidor</span>
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.exp_cnpj }}
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.exp_ie }}
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.exp_nome }}
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.exp_endereco }} -
                  {{ rowData.doc_cte_partes_env.exp_complemento }} -
                  {{ rowData.doc_cte_partes_env.exp_numero }}
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.exp_bairro }}
                </td>
                <td>
                  <span v-if="rowData.doc_cte_partes_env.exp_cep">{{
                    rowData.doc_cte_partes_env.exp_cep.toString().padStart(8, "0")
                  }}</span>
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.exp_nome_municipio }}
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.exp_uf }}
                </td>
                <td>
                  <span v-if="rowData.doc_cte_partes_env.exp_email">{{
                    rowData.doc_cte_partes_env.exp_email
                  }}</span>
                </td>
                <td>
                  <span v-if="rowData.doc_cte_partes_env.exp_telefone">{{
                    rowData.doc_cte_partes_env.exp_telefone
                  }}</span>
                </td>
                <td>
                  <span v-if="getPermission('cte.cderp')"
                    ><a
                      @click="
                        onAlterarCdErp(
                          rowData.doc_cte_partes_env.doctpaen_id,
                          3
                        )
                      "
                      v-b-tooltip
                      title="Alterar CD ERP"
                      ><i class="fa fa-plus"></i></a
                  ></span>
                </td>
              </tr>
            </tbody>

            <tbody>
              <tr
                class="bg-gray-light"
                style="display: table-row"
                v-if="rowData.doc_cte_partes_env.des_endereco"
              >
                <td>
                  <span class="badge badge-success">Destinatário</span>
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.des_cnpj }}
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.des_ie }}
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.des_nome }}
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.des_endereco }} -
                  {{ rowData.doc_cte_partes_env.des_complemento }} -
                  {{ rowData.doc_cte_partes_env.des_numero }}
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.des_bairro }}
                </td>
                <td>
                  <span v-if="rowData.rowData.doc_cte_partes_env.des_cep">{{
                    rowData.rowData.doc_cte_partes_env.des_cep.toString().padStart(8, "0")
                  }}</span>
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.des_nome_municipio }}
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.des_uf }}
                </td>
                <td>
                  <span v-if="rowData.doc_cte_partes_env.des_email">{{
                    rowData.doc_cte_partes_env.des_email
                  }}</span>
                </td>
                <td>
                  <span v-if="rowData.doc_cte_partes_env.des_telefone">{{
                    rowData.doc_cte_partes_env.des_telefone
                  }}</span>
                </td>
                <td>
                  <span v-if="getPermission('cte.cderp')"
                    ><a
                      @click="
                        onAlterarCdErp(
                          rowData.doc_cte_partes_env.doctpaen_id,
                          2
                        )
                      "
                      v-b-tooltip
                      title="Alterar CD ERP"
                      ><i class="fa fa-plus"></i></a
                  ></span>
                </td>
              </tr>
            </tbody>

            <tbody>
              <tr
                class="bg-gray-light"
                style="display: table-row"
                v-if="rowData.doc_cte_partes_env.rec_endereco"
              >
                <td>
                  <span class="badge badge-secondary">Recebedor</span>
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.rec_cnpj }}
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.rec_ie }}
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.rec_nome }}
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.rec_endereco }} -
                  {{ rowData.doc_cte_partes_env.rec_complemento }} -
                  {{ rowData.doc_cte_partes_env.rec_numero }}
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.rec_bairro }}
                </td>
                <td>
                  <span v-if="rowData.doc_cte_partes_env.rec_cep">{{
                    rowData.doc_cte_partes_env.rec_cep.toString().padStart(8, "0")
                  }}</span>
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.rec_nome_municipio }}
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.rec_uf }}
                </td>
                <td>
                  <span v-if="rowData.doc_cte_partes_env.rec_email">{{
                    rowData.doc_cte_partes_env.rec_email
                  }}</span>
                </td>
                <td>
                  <span v-if="rowData.doc_cte_partes_env.rec_telefone">{{
                    rowData.doc_cte_partes_env.rec_telefone
                  }}</span>
                </td>
                <td>
                  <span v-if="getPermission('cte.cderp')"
                    ><a
                      @click="
                        onAlterarCdErp(
                          rowData.doc_cte_partes_env.doctpaen_id,
                          4
                        )
                      "
                      v-b-tooltip
                      title="Alterar CD ERP"
                      ><i class="fa fa-plus"></i></a
                  ></span>
                </td>
              </tr>
            </tbody>

            <tbody>
              <tr
                class="bg-gray-light"
                style="display: table-row"
                v-if="rowData.doc_cte_partes_env.tom_endereco"
              >
                <td>
                  <span class="badge badge-secondary">Tomador</span>
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.tom_cnpj }}
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.tom_ie }}
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.tom_nome }}
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.tom_endereco }} -
                  {{ rowData.doc_cte_partes_env.tom_complemento }} -
                  {{ rowData.doc_cte_partes_env.tom_numero }}
                </td>
                <td>
                  <span v-if="rowData.doc_cte_partes_env.tom_cep">{{
                    rowData.doc_cte_partes_env.tom_cep.toString().padStart(8, "0")
                  }}</span>
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.tom_bairro }}
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.tom_nome_municipio }}
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.tom_uf }}
                </td>
                <td>
                  <span v-if="rowData.doc_cte_partes_env.tom_email">{{
                    rowData.doc_cte_partes_env.tom_email
                  }}</span>
                </td>
                <td>
                  <span v-if="rowData.doc_cte_partes_env.tom_telefone">{{
                    rowData.doc_cte_partes_env.tom_telefone
                  }}</span>
                </td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          role="tabpanel"
          class="tab-pane fade pt-1 border-color-detalhes-grey"
          v-bind:id="'t2' + rowData.doc_id + ''"
        >
          <table class="table-striped" id="mais">
            <thead>
              <tr>
                <th style="width: 10%">Valor CTE</th>
                <th style="width: 20%">Tipo serviço</th>
                <th style="width: 20%">Tipo CTE</th>
                <th style="width: 10%">CFOP</th>
                <th style="width: 10%">Chave</th>
              </tr>
            </thead>
            <tbody>
              <tr class="bg-gray-light" style="display: table-row">
                <td>
                  {{ formatNumber(rowData.vlr_prestacao) }}
                </td>
                <td>
                  {{ rowData.doc_cte.tp_servico.descr }}
                </td>
                <td>
                  {{ rowData.doc_cte.tp_cte.descr }}
                </td>
                <td>
                  {{ rowData.doc_cte.cfop }}.{{
                    rowData.doc_cte.natureza_operacao
                  }}
                </td>
                <td>
                  {{ rowData.doc_cte.chave }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
      </div>
      <!--.tab-content-->
    </div>
  </div>
</template>

  <script>
import accounting from "accounting";
import moment from "moment";

import { formatCNPJFromParts } from "../utils";

export default {
  data() {
    return {
      helpForm: new Form({ statusRecord: [], params: [] })
    };
  },
  props: {
    rowData: {
      type: Object,
      required: true
    },
    rowIndex: {
      type: Number
    }
  },
  methods: {
    getPermission(checkPermission) {
      return this.getPermissionFw(checkPermission);
    },
    onAlterarCdErp(doctpaen_id, tipo_erp) {
      Event.$emit("alterarcderp", doctpaen_id, tipo_erp);
    },
    formatNumber(value) {
      return accounting.formatNumber(value, 2, ".", ",");
    },
        onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito) {
      return formatCNPJFromParts(cnpj_base, cnpj_filial, cnpj_digito);
    },
  }
};
</script>